import {ValueObject} from '@s-ui/domain'

import {NumberSharedValueObject} from '../../shared/ValueObjects/NumberSharedValueObject.js'
import {DealerProfileTagsListRatingsValueObject} from './DealerProfileTagsListRatingsValueObject.js'

export class DealerProfileRatingsValueObject extends ValueObject {
  #average
  #tags
  #totalReviews

  constructor({average, tags, totalReviews}) {
    super()
    this.#average = average
    this.#tags = tags
    this.#totalReviews = totalReviews
  }

  static createFromApiResponse({badges, commentsNumber, scoreAverage}) {
    return new DealerProfileRatingsValueObject({
      average: NumberSharedValueObject.create({value: scoreAverage}),
      tags: DealerProfileTagsListRatingsValueObject.createFromPrimitives({value: badges || []}),
      totalReviews: NumberSharedValueObject.create({value: commentsNumber})
    })
  }

  static createFromListingApi({ratings}) {
    return new DealerProfileRatingsValueObject({
      average: ratings.scoreAverage ? NumberSharedValueObject.create({value: ratings.scoreAverage}) : {},
      tags: DealerProfileTagsListRatingsValueObject.createFromPrimitives({value: ratings.badges || []}),
      totalReviews: ratings.commentsNumber ? NumberSharedValueObject.create({value: ratings.commentsNumber}) : {}
    })
  }

  get average() {
    return this.#average.value
  }

  get hasRatings() {
    return !isNaN(this.#average.value)
  }

  get hasReviews() {
    return this.#totalReviews.value > 0
  }

  get tags() {
    return this.#tags.value
  }

  get totalReviews() {
    return this.#totalReviews.value
  }

  get value() {
    return {
      average: this.average,
      tags: this.tags,
      totalReviews: this.totalReviews
    }
  }
}
